import React from 'react';
// 1. Import 'styled' and 'keyframes' from your stitches config
import { styled, keyframes } from '../styles/stitches.config'; // Adjust path if needed
import { useOnline } from '../hooks/useOnline'; // Adjust path if needed
import { WifiOff } from 'lucide-react';

// 2. Create the keyframe using the stitches keyframes() helper
const fadeIn = keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(10px)',
  },
  '100%': {
    opacity: 1,
    transform: 'translateY(0)',
  },
});

// 3. Create the styled component using stitches object syntax
const OfflineBanner = styled('div', {
  position: 'fixed',
  bottom: '20px', // or use a token like '$4' if you have one
  left: '20px',  // or use a token like '$4'
  
  backgroundColor: '#222', // or use a token like '$gray900'
  color: '#fff',          // or use a token like '$gray100'
  padding: '12px 16px',   // or use tokens
  borderRadius: '8px',    // or use a token like '$radius2'
  
  display: 'flex',
  alignItems: 'center',
  gap: '10px',            // or use a token like '$2'
  
  zIndex: 10000,
  // 4. Apply the animation variable
  animation: `${fadeIn} 0.3s ease-out`,
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
});

// 5. The React component logic remains exactly the same
export const OfflineIndicator: React.FC = () => {
  const isOnline = useOnline();

  // If the user is online, render nothing.
  if (isOnline) {
    return null;
  }

  // If the user is offline, show the permanent banner.
  return (
    <OfflineBanner>
      <WifiOff size={18} style={{stroke: 'white'}}/>
      You are currently offline.
    </OfflineBanner>
  );
};